import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'bootstrap-datepicker'
import { loadPhoneInput, validateInput, resetValidations } from '../../modules/phone_input'

export default class extends Controller {
  static targets = [
    'companyPhoneInput',
    'companyValidMsg',
    'companyErrorMsg',
    'directorPhoneInput',
    'directorValidMsg',
    'directorErrorMsg',
    'kycForm',
  ]


  connect() {
    window.addEventListener('load', () => this._loadCompanyPhoneInput())
    window.addEventListener('load', () => this._loadDirectorPhoneInput())

    this._kycFormValidation()
    this._loadCompanyPhoneInput()
    this._loadDirectorPhoneInput()
  }

  _loadCompanyPhoneInput() {
    if (this.itiCompany) return
    this.itiCompany = loadPhoneInput(
      this.companyPhoneInputTarget,
      this.data.get('country'),
      this.companyErrorMsgTarget,
      this.companyValidMsgTarget
    )
  }

  _loadDirectorPhoneInput() {
    if (this.itiDirector) return
    this.itiDirector = loadPhoneInput(
      this.directorPhoneInputTarget,
      this.data.get('country'),
      this.directorErrorMsgTarget,
      this.directorValidMsgTarget
    )
  }

  _validateCompanyInput() {
    return validateInput(
      this.itiCompany,
      this.companyPhoneInputTarget,
      this.companyErrorMsgTarget,
      this.companyValidMsgTarget
    )
  }

  _validateDirectorInput() {
    return validateInput(
      this.itiDirector,
      this.directorPhoneInputTarget,
      this.directorErrorMsgTarget,
      this.directorValidMsgTarget
    )
  }

  _resetCompanyValidations() {
    resetValidations(
      this.companyPhoneInputTarget,
      this.companyErrorMsgTarget,
      this.companyValidMsgTarget
    )
  }

  _resetDirectorValidations() {
    resetValidations(
      this.directorPhoneInputTarget,
      this.directorErrorMsgTarget,
      this.directorValidMsgTarget
    )
  }

  _kycFormValidation() {
    if (!this.kycFormTarget) return

    var self = this
    this.kycFormTarget.addEventListener('submit', function (e) {
      var isValid =
        self._validateCompanyInput() && self._validateDirectorInput()

      if (isValid) {
        document
          .querySelector('input[type=submit]')
          .setAttribute('disabled', true)
        return
      }

      e.preventDefault()
    })
  }
}
